"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bannerModule = _interopRequireDefault(require("./sass/banner.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Banner = function Banner(_ref) {
  var className = _ref.className,
      background = _ref.background,
      color = _ref.color,
      cta = _ref.cta,
      icon = _ref.icon,
      text = _ref.text;
  return /*#__PURE__*/_react.default.createElement("section", {
    className: "".concat(_bannerModule.default.container + ' ' + className),
    style: {
      background: background
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: _bannerModule.default.container_icon + ' ' + className + '_icon',
    src: icon,
    alt: ""
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: _bannerModule.default.container_text + ' ' + className + '_text',
    style: {
      color: color
    }
  }, text), /*#__PURE__*/_react.default.createElement("div", {
    className: className + '_cta'
  }, cta));
};

Banner.defaultProps = {
  background: null,
  className: 'banner',
  color: null,
  cta: /*#__PURE__*/_react.default.createElement("p", null, "CTA Content"),
  icon: null,
  text: null
};
Banner.propTypes = {
  background: _propTypes.default.string,
  className: _propTypes.default.string,
  color: _propTypes.default.string,
  cta: _propTypes.default.element,
  icon: _propTypes.default.string,
  text: _propTypes.default.string
};
var _default = Banner;
exports.default = _default;